/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './revokeAccountCredentials.defs.js'
export { main as default } from './revokeAccountCredentials.defs.js'
